import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { DepartmentService } from '../../../service/department/department.service';
import { Department } from '../../../class/department';

@Component({
  selector: 'app-department',
  templateUrl: './department.component.html',
  styleUrls: ['./department.component.scss']
})
export class DepartmentComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoDepartment: Department;
    public department: Department;
    public msgs: Message[] = [];
    public options: any;

    constructor(
        public departmentService: DepartmentService,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
    }

    public cancelDepartment () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/departments/department/department.component.ts